import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNewyorktimesComponent } from './simple-icons-newyorktimes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNewyorktimesComponent ],
    exports:      [ SimpleIconsNewyorktimesComponent ],
    bootstrap:    []
})
export class SimpleIconsNewyorktimesModule {}
